<template>
    <div>
        <v-toolbar card dark color="primary" class="cabecalho cabecalho-etapas">
            <v-btn class="botao-voltar text-uppercase" @click="voltar" flat depressed>
                <i class="fas fa-arrow-left mr-2" aria-hidden="true"/>
                <span class="texto">Voltar</span>
            </v-btn>

            <div class="cabecalho__texto">
                <div class="cabecalho__info">
                    <p>
                        <strong>Nº Processo</strong><br>
                        {{ resumoCompraDireta.processo ? resumoCompraDireta.processo : '--' }}
                        <br>
                        <span v-if="resumoCompraDireta.quantidadeRepeticoes">
                            <strong> Repetição: {{resumoCompraDireta.quantidadeRepeticoes}} </strong>
                        </span>
                    </p>
                    <p>
                        <strong>{{ $t('main.fornecedor_commons_cabecalho_pagina_orgao.text') }}</strong><br>
                        {{ resumoCompraDireta.orgao ? resumoCompraDireta.orgao : '--' }}
                    </p>
                    <p v-if="resumoCompraDireta.tipo === 'COM_DISPUTA' && resumoCompraDireta.processo !== 'SEPLAG-PRO-2025/23595'">
                        <strong>Disputa por</strong><br>
                        {{ resumoCompraDireta.disputaPor | cdEnum(disputasCompraDireta) }}
                    </p>
                    <p v-if="deveMostrarTempoRandomico">
                        <strong>Tempo Randômico</strong><br>
                        De 1 a {{ resumoCompraDireta.tempoRandomicoLance ? resumoCompraDireta.tempoRandomicoLance : '--' }} minutos <br> após o encerramento
                    </p>
                    <p v-if="resumoCompraDireta.criterioJulgamento && resumoCompraDireta.processo !== 'SEPLAG-PRO-2025/23595'">
                      <strong>Critério Julgamento</strong><br>
                      <span>
                          {{ resumoCompraDireta.criterioJulgamento === 'MAIOR_DESCONTO' ? 'Maior Desconto' : 'Menor Preço' }}
                      </span>
                    </p>
                    <p v-if="resumoCompraDireta.intervaloLancesPor && ehALei14_133">
                        <strong>Diferença Mínima entre Lances</strong><br>
                        <span>
                              {{ montarDiferencaEntreLances }}
                          </span>
                    </p>
                </div>

                <div class="cabecalho-mobile__titulo">
                    <span>Compra Direta</span>
                </div>

                <salvamento-automatico class="mr-2"/>

                <button class="cabecalho-mobile__botao" @click="exibirInformacoes">
                    <i class="fas fa-file" aria-hidden="true"/>
                </button>
            </div>
        </v-toolbar>

        <div v-if="exibirInformacoesMobile" class="cabecalho-mobile__info">
            <p>
                <strong>Nº Processo</strong>
                {{ resumoCompraDireta.processo ? resumoCompraDireta.processo : '--' }}
            </p>
            <p>
                <strong>{{ $t('main.fornecedor_commons_cabecalho_pagina_orgao.text') }}</strong>
                {{ resumoCompraDireta.orgao ? resumoCompraDireta.orgao : '--' }}
            </p>
            <p v-if="resumoCompraDireta.tipo === 'COM_DISPUTA' && resumoCompraDireta.processo !== 'SEPLAG-PRO-2025/23595'">
                <strong>Disputa por</strong>
                {{ resumoCompraDireta.disputaPor | cdEnum(disputasCompraDireta) }}
            </p>
            <p v-if="deveMostrarTempoRandomico">
                <strong>Tempo Randômico</strong>
                De 1 a {{ resumoCompraDireta.tempoRandomicoLance ? resumoCompraDireta.tempoRandomicoLance : '--' }} minutos <br> após o encerramento
            </p>
        </div>
    </div>
</template>

<script>
import {actionTypes, disputasCompraDireta, validacaoIntervaloLances} from '@/core/constants'
import {mapState} from 'vuex'

export default {
    name: 'CabecalhoPagina',
    data() {
        return {
            compraDiretaId: null,
            propostaId: null,
            exibirInformacoesMobile: false,
            disputasCompraDireta,
            mostrarOpcoesDownload: false,
            validacaoIntervaloLances
        }
    },
    props: {
        exibirProtocolo: {
            type: Boolean,
            default: true
        },
        ehALei14_133:{
            type: Boolean,
            default: false
        },
        deveMostrarTempoRandomico:{
            type: Boolean,
            default: false
        },
        ehTelaResultado:{
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState(['resumoCompraDireta', 'chat']),
        montarDiferencaEntreLances(){
            return '--'
        },
        totalMensagensNaoLidaCentral(){
            return this.chat.centralMensagens.totalNaoLidas
        }
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarDados()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarDados() {
        },
        voltar() {
            this.$router.push({
                name: 'Resultado',
                params: { id: this.compraDiretaId }
            })
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
        exibirInformacoes() {
            this.exibirInformacoesMobile = !this.exibirInformacoesMobile
        },
        tratarEventoCliqueDownload(){
            if(this.resumoCompraDireta.idProtocoloVirtualizado != null){
                this.abrirOpcoesDownload()
            }else{
                this.baixarProtocoloPreview()
            }
        },
        async baixarProtocoloPreview(){
            const infoObj={
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.BAIXAR_RELATORIO_DE_PROTOCOLO_PREVIEW, infoObj)
        }
    }
}
</script>

<style scoped lang="stylus">
    .botao-voltar
        margin 0 !important
        width 120px
        background-color var(--v-primary-base)
        border-right 1px solid rgba(255, 2555, 2555, .5)
        font-size 12px

    .cabecalho
        position fixed
        z-index 999
        box-shadow 0 2px 4px -1px rgba(0, 0, 0, .4)

        &__texto
            justify-content space-between
            width 93%
            align-items center
            font-size 12px

            p
                margin 0 20px
                line-height 13px

        &__info, &__texto
            display flex

        &__info
            align-items normal

        &__link
            text-decoration underline
            cursor pointer
            color #fff

        &-mobile
            &__botao
                display none
                height 48px
                width 50px
                font-size 16px
                background-color var(--v-primary-darken1)

                &:hover, &:active, &:focus
                    background-color var(--v-primary-darken2)
                    outline 0

            &__info
                padding 54px 0 0
                margin 0
                font-size 13px
                color #777
                display none
                -webkit-transition all 1s cubic-bezier(0, 1, .5, 1)
                -moz-transition all 1s cubic-bezier(0, 1, .5, 1)
                -ms-transition all 1s cubic-bezier(0, 1, .5, 1)
                transition all 1s cubic-bezier(0, 1, .5, 1)
                z-index 2
                position fixed
                background-color #fff
                width 100%
                box-shadow 0 2px 4px -1px rgba(0, 0, 0, .4)

                p
                    margin-bottom 0
                    border-style solid
                    border-width 0 1px 1px
                    border-color #ebebeb
                    padding 10px
                    display flex
                    justify-content space-between
                    text-align right

                strong
                    margin-right 10px

            &__titulo
                font-size 14px
                font-weight 600
                display none
                margin 0 auto
                text-transform uppercase

    @media(max-width 1430px)
        .cabecalho__texto
            width 100%
            flex-wrap wrap

    @media(max-width 1200px)
        .cabecalho__texto p
            margin 0 10px

        .botao-voltar
            padding 0
            margin 0 !important
            flex 0

        .cabecalho__texto, .botao-voltar
            font-size 11px

    @media(max-width 775px)
        .cabecalho
            &__info, .botao-voltar .texto
                display none

            &-mobile__botao, &-mobile__info, &-mobile__titulo
                display block

            .botao-voltar
                font-size 16px
                border-right 0
                min-width 60px

            &__link
                color #777

    @media(max-width 523px)
        .cabecalho-mobile__botao
            height 56px
</style>
